var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 py-2"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('img',{attrs:{"src":require("../assets/logo.png")}}),(_vm.$route.path !== '/')?_c('router-link',{attrs:{"to":"/"}},[_c('b-button',{staticClass:"bg-primary text-white"},[_vm._v("Back")])],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }